import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { buttonTheme } from '../button-theme';

export const buttonBaseStyle = css`
  background: ${buttonTheme.backgroundColor};
  border-left: 2px solid ${buttonTheme.pressedColor};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 250ms ease-out;

  &:hover,
  &:focus {
    background: ${buttonTheme.hoverColor};
    outline: none;
  }

  &:active {
    background: ${buttonTheme.pressedColor};
  }

  &:disabled {
    background: ${buttonTheme.disabled.backgroundColor};
    border-color: ${theme.colors.neutral30};
    cursor: default;
  }

  > svg {
    color: white;
  }
`;

export const buttonSizeStyles = {
  large: css`
    width: 64px;
    height: 40px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: ${theme.spacing(2)};

    &:hover,
    &:focus {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  `,
  small: css`
    width: 56px;
    height: 32px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: ${theme.spacing(1)};

    &:hover,
    &:focus {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  `,
};

export const buttonActiveStyle = css`
  background: ${buttonTheme.hoverColor};
`;
